module.exports = __webpack_public_path__ + "static/media/previousPage.bfade37a.svg";